/* eslint-disable */
import { isObject } from './index';

const TokenKey = 'Token';
const UserInfo = 'UserInfo';

export function getToken() {
  // return localStorage.getItem(TokenKey);
  return sessionStorage.getItem('jupiterToken');
}

export function getSystemToken() {
  return localStorage.getItem(SystemToken) || '';
}

export function setToken(token) {
  localStorage.setItem(TokenKey, token);
}

export function removeToken() {
  localStorage.removeItem(TokenKey);
  localStorage.removeItem(SystemToken);
}

export function setUserLocalData(obj) {
  if (isObject(obj)) {
    let str = '';

    try {
      str = JSON.stringify(obj);
    } catch (e) {
      console.log('用户信息格式错误');
    }

    localStorage.setItem(UserInfo, str);
  } else {
    console.log('用户信息格式错误');
  }
}

export function getUserLocalData() {
  const str = localStorage.getItem(UserInfo) || '{}';
  const obj = JSON.parse(str);
  return obj;
}

export function setTime(timeData) {
  if (!isObject(timeData)) return;
  const oldValue = sessionStorage.getItem(TIME) || '[]';
  let oldValueArr = JSON.parse(oldValue);
  const timestap = new Date().getTime();

  const expFilter = oldValueArr.filter((item) => timestap - item.time < EXP);
  oldValueArr = expFilter;

  const res = oldValueArr.find((item) => item.key === timeData.key);

  if (res) {
    for (let i = 0, l = oldValueArr.length; i < l; i++) {
      if (oldValueArr[i].key === timeData.key) {
        oldValueArr[i].value = timeData.value;
        oldValueArr[i].time = timestap;
        break;
      }
    }
  } else {
    timeData.time = timestap;
    oldValueArr.push(timeData);
  }

  const newValueJSON = JSON.stringify(oldValueArr);

  sessionStorage.setItem(TIME, newValueJSON);
}

export function getTime(key) {
  const timestap = new Date().getTime();
  const str = sessionStorage.getItem(TIME) || '[]';
  const arr = JSON.parse(str);

  const resFilter = arr.find((item) => item.key === key);
  let res = 0;

  if (resFilter) {
    if (timestap - resFilter.time < EXP) {
      res = resFilter.value;
    }
  }
  return res;
}

export function initSocketMsgData(data) {
  const localData = getUserLocalData();
  const baseData = {
    role: 'STUDENT',
    user_id: parseInt(localData.user_id),
    subject_id: parseInt(localData.subject_id),
    school_id: parseInt(localData.school_id),
    course_id: parseInt(localData.course_id),
    // lesson_id: parseInt(localData.lessonId),
    // topic_id: parseInt(localData.topicId),
    // flow_id: parseInt(localData.flowId),
    stage: parseInt(localData.stage),
    nick: localData.user_name,
    // app_type: parseInt(localData.appType),
    // client_ip: localData.clientIp,
    learning_version: 2, // （1=v1, 2=v2），只有接入学习系统v2的学科新加这个字
  };
  const msg = { ...baseData, ...data };
  return msg;
}
